<template>
    <i class="z-icon" v-on:click="onClick">
        <fa-icon v-if="$props.icon" v-bind:icon="$props.icon"></fa-icon>
    </i>
</template>
<script>
    export default {
        name: 'z-icon',
        props: {
            icon: {
                type: [String, Array, Object],
                default: () => [],
                required: true
            }
        },
        data() {
            return {}
        },
        created() {},
        watch: {},
        computed: {},
        methods: {
            onClick(e) {
                this.$emit('click', e);
            }
        }
    }
</script>
<style lang="sass">
    .z-icon
        font-size: var(--a-icon-size-x35)
        line-height: var(--a-icon-size-x35)
        color: var(--color-secondary-800)
</style>


// WEBPACK FOOTER //
// ZIcon.vue?d5f39eba